import { all, call } from 'redux-saga/effects';

import facebookFlow from './facebook';
import snapaskFlow from './snapask';

export default function*() {
  yield all([call(facebookFlow), call(snapaskFlow)]);
}



// WEBPACK FOOTER //
// ./app/sagas/signup/index.js